// =============================================================================
// SEO DATA AND STRUCTURED DATA
// =============================================================================

export const businessStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Alex Finger Consulting",
  "description": "Web development and business strategy services. Transform your ideas into digital reality with rapid prototyping and strategic development.",
  "url": "https://alexfinger.com",
  "logo": "https://alexfinger.com/images/logo.png",
  "image": "https://alexfinger.com/images/logo.png",
  "foundingDate": "2020",
  "founder": {
    "@type": "Person",
    "name": "Alex Finger",
    "jobTitle": "Full-Stack Developer & Business Strategist",
    "description": "Full-stack developer and business strategist with over 20 years of experience in web development and business strategy.",
    "url": "https://alexfinger.com/about",
    "image": "https://alexfinger.com/images/logo.png",
    "sameAs": [
      "https://www.linkedin.com/in/alex-finger-71117336a/"
    ]
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "US"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Business Inquiries",
    "url": "https://alexfinger.com/contact"
  },
  "sameAs": [
    "https://www.linkedin.com/in/alex-finger-71117336a/"
  ],
  "serviceArea": {
    "@type": "Country",
    "name": "United States"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Alex Finger Consulting Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web Development",
          "description": "Full-stack web applications built with React, TypeScript, Node.js, and modern cloud infrastructure.",
          "provider": {
            "@type": "Organization",
            "name": "Alex Finger Consulting"
          }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Business Strategy & Consulting",
          "description": "Comprehensive business development services including market analysis, product strategy, and growth planning.",
          "provider": {
            "@type": "Organization",
            "name": "Alex Finger Consulting"
          }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Rapid Prototyping",
          "description": "Get your idea to market quickly with streamlined prototyping process. MVP in under a week.",
          "provider": {
            "@type": "Organization",
            "name": "Alex Finger Consulting"
          }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Technical Coaching",
          "description": "Learn how to start and grow your own software development business with personalized coaching.",
          "provider": {
            "@type": "Organization",
            "name": "Alex Finger Consulting"
          }
        }
      }
    ]
  }
};

export const personStructuredData = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Alex Finger",
  "jobTitle": "Full-Stack Developer & Business Strategist",
  "description": "Full-stack developer and business strategist with over 20 years of experience in web development and business strategy. Specializes in rapid prototyping and transforming ideas into digital reality.",
  "url": "https://alexfinger.com/about",
  "image": "https://alexfinger.com/images/logo.png",
  "sameAs": [
    "https://www.linkedin.com/in/alex-finger-71117336a/"
  ],
  "knowsAbout": [
    "Web Development",
    "Business Strategy",
    "React",
    "TypeScript",
    "Node.js",
    "Rapid Prototyping",
    "Software Development",
    "Digital Product Development",
    "Business Coaching"
  ],
  "alumniOf": "Software Development Industry",
  "hasOccupation": {
    "@type": "Occupation",
    "name": "Full-Stack Developer & Business Strategist",
    "description": "Transforms innovative ideas into powerful digital products through strategic development, rapid prototyping, and iterative growth.",
    "occupationLocation": {
      "@type": "Country",
      "name": "United States"
    }
  }
};

export const websiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Alex Finger Consulting",
  "description": "Web development and business strategy services. Transform your ideas into digital reality.",
  "url": "https://alexfinger.com",
  "publisher": {
    "@type": "Organization",
    "name": "Alex Finger Consulting",
    "logo": {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "width": 1024,
      "height": 1024,
      "caption": "Alex Finger Consulting Logo"
    }
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://alexfinger.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const serviceStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Alex Finger Consulting Services",
  "description": "Comprehensive web development and business strategy services including rapid prototyping, custom web applications, and technical coaching.",
  "provider": {
    "@type": "Organization",
    "name": "Alex Finger Consulting",
    "url": "https://alexfinger.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Development Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web Development",
          "description": "Full-stack web applications with modern technologies",
          "image": "https://alexfinger.com/images/logo.png"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Business Strategy",
          "description": "Strategic development and market analysis",
          "image": "https://alexfinger.com/images/logo.png"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Rapid Prototyping",
          "description": "MVP development in under a week",
          "image": "https://alexfinger.com/images/logo.png"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Technical Coaching",
          "description": "Learn to build your own development company",
          "image": "https://alexfinger.com/images/logo.png"
        }
      }
    ]
  }
};

// Service-specific structured data for better SEO
export const serviceImagesStructuredData = {
  "@context": "https://schema.org",
  "@type": "ImageGallery",
  "name": "Alex Finger Consulting Service Icons",
  "description": "Visual representation of our core services: web development, business strategy, iterative development, technical excellence, coaching, and support.",
  "url": "https://alexfinger.com/services",
  "image": [
    {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "name": "Web Development Services",
      "description": "Custom digital solutions and applications",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "name": "Business Strategy Services",
      "description": "Strategic planning and market analysis",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "name": "Iterative Development Process",
      "description": "Continuous improvement and agile methodology",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "name": "Technical Excellence",
      "description": "Modern technologies and best practices",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "name": "Technical Coaching Services",
      "description": "Learn to build your own development company",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://alexfinger.com/images/logo.png",
      "name": "End-to-End Support Services",
      "description": "Comprehensive technical and strategic guidance",
      "width": 1024,
      "height": 1024
    }
  ]
};

// Page-specific SEO data
export const seoData = {
  home: {
    title: "Alex Finger Consulting - Web Development & Business Strategy",
    description: "Transform your ideas into digital reality with rapid prototyping and strategic development. Full-stack web applications, business strategy, and technical coaching services.",
    keywords: "web development, business strategy, React, TypeScript, rapid prototyping, MVP development, software development, digital products, business coaching, full-stack developer",
    canonicalUrl: "/",
    structuredData: [businessStructuredData, websiteStructuredData, serviceStructuredData, serviceImagesStructuredData]
  },
  about: {
    title: "About Alex Finger - Full-Stack Developer & Business Strategist",
    description: "Learn about Alex Finger, a full-stack developer and business strategist with 20+ years of experience. Specializing in transforming ideas into digital reality through rapid prototyping and strategic development.",
    keywords: "Alex Finger, about, full-stack developer, business strategist, web development, software development, rapid prototyping, business strategy, technical expertise",
    canonicalUrl: "/about",
    structuredData: [personStructuredData, businessStructuredData]
  },
  services: {
    title: "Web Development Services - Alex Finger Consulting",
    description: "Comprehensive web development services including custom applications, business strategy, rapid prototyping, and technical coaching. From concept to market-ready solutions in under a week.",
    keywords: "web development services, custom web applications, business strategy, rapid prototyping, React development, TypeScript, Node.js, SaaS development, technical consulting",
    canonicalUrl: "/services",
    structuredData: [serviceStructuredData, businessStructuredData, serviceImagesStructuredData]
  },
  portfolio: {
    title: "Live Portfolio | Alex Finger Consulting",
    description: "Explore a living portfolio of active client projects that demonstrate the power of iterative, data-driven development. See real-time growth and continuous improvement in action.",
    keywords: "live portfolio, web development portfolio, iterative development, client projects, continuous improvement, React projects, data-driven development",
    canonicalUrl: "/portfolio",
    structuredData: [businessStructuredData, {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Alex Finger Consulting Portfolio",
      "description": "Live portfolio showcasing iterative development projects and client success stories",
      "itemListElement": [
        {
          "@type": "WebSite",
          "name": "The Yoga Encyclopedia",
          "url": "https://theyogaencyclopedia.com",
          "description": "Comprehensive health and wellness platform with continuous development"
        },
        {
          "@type": "WebSite",
          "name": "Novel Novela",
          "url": "https://novelnovela.com",
          "description": "Interactive choose your own adventure platform with evolving features"
        }
      ]
    }]
  },
  coaching: {
    title: "Software Development Coaching - Build Your Own Company",
    description: "Learn how to start and grow your own software development business. Personalized coaching on technical skills, business development, and client acquisition strategies.",
    keywords: "software development coaching, business coaching, learn web development, start software company, technical mentorship, business development, client acquisition, software business",
    canonicalUrl: "/coaching",
    structuredData: [businessStructuredData]
  },
  contact: {
    title: "Contact Alex Finger Consulting - Start Your Project",
    description: "Ready to transform your idea into digital reality? Contact Alex Finger Consulting for web development, business strategy, and technical coaching services. Get started today.",
    keywords: "contact, web development consultation, business strategy consultation, project inquiry, technical coaching, software development services, get started",
    canonicalUrl: "/contact",
    structuredData: [businessStructuredData]
  },
  privacy: {
    title: "Privacy Policy - Alex Finger Consulting",
    description: "Privacy policy for Alex Finger Consulting. Learn how we collect, use, and protect your personal information.",
    keywords: "privacy policy, data protection, personal information, Alex Finger Consulting",
    canonicalUrl: "/privacy",
    noIndex: true
  },
  terms: {
    title: "Terms of Service - Alex Finger Consulting",
    description: "Terms of service for Alex Finger Consulting. Read our terms and conditions for using our services.",
    keywords: "terms of service, terms and conditions, Alex Finger Consulting, legal terms",
    canonicalUrl: "/terms",
    noIndex: true
  },
  notfound: {
    title: "404 - Page Not Found | Alex Finger Consulting",
    description: "The page you're looking for doesn't exist. Browse our services, portfolio, or contact us for web development and business strategy solutions.",
    keywords: "404, page not found, Alex Finger Consulting",
    canonicalUrl: "/404",
    noIndex: true
  },
  // Individual project pages
  'yoga-encyclopedia': {
    title: "The Yoga Encyclopedia - Live Project | Alex Finger Consulting",
    description: "Explore The Yoga Encyclopedia, a comprehensive health and wellness platform built with React and TypeScript. See iterative development in action with continuous improvements and real growth metrics.",
    keywords: "yoga encyclopedia, wellness platform, React development, TypeScript, health website, iterative development, live project, Alex Finger Consulting",
    canonicalUrl: "/portfolio/yoga-encyclopedia",
    structuredData: [{
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "The Yoga Encyclopedia",
      "description": "A comprehensive digital platform dedicated to yoga, wellness, and holistic health",
      "url": "https://theyogaencyclopedia.com",
      "publisher": {
        "@type": "Organization",
        "name": "Alex Finger Consulting"
      },
      "dateCreated": "2025",
      "inLanguage": "en-US"
    }]
  },
  'novel-novela': {
    title: "Novel Novela - Interactive Fiction Platform | Alex Finger Consulting",
    description: "Discover Novel Novela, an interactive choose-your-own-adventure platform built with React and TypeScript. Experience iterative development with continuous feature updates and user engagement improvements.",
    keywords: "novel novela, interactive fiction, choose your own adventure, React development, TypeScript, storytelling platform, live project, Alex Finger Consulting",
    canonicalUrl: "/portfolio/novel-novela",
    structuredData: [{
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Novel Novela",
      "description": "A modern take on interactive fiction, bringing choose-your-own-adventure stories to the digital age",
      "url": "https://novelnovela.com",
      "publisher": {
        "@type": "Organization",
        "name": "Alex Finger Consulting"
      },
      "dateCreated": "2025",
      "inLanguage": "en-US"
    }]
  }
};
